/**
 * Convert 24-hour format time string (HH:mm) to 12-hour format (h:mm AM/PM)
 * @param {string} time24 - Time in 24-hour format (e.g., "01:00", "13:30", "23:45")
 * @returns {string} - Time in 12-hour format (e.g., "1:00 AM", "1:30 PM", "11:45 PM")
 */
export const convertTo12Hour = (time24) => {
  if (!time24 || typeof time24 !== 'string') return time24;
  
  const [hours, minutes] = time24.split(':').map(Number);
  if (isNaN(hours) || isNaN(minutes)) return time24;
  
  const period = hours >= 12 ? 'PM' : 'AM';
  let hour12 = hours % 12;
  if (hour12 === 0) hour12 = 12; // 0:00 and 12:00 both become 12
  
  return `${hour12}:${String(minutes).padStart(2, '0')} ${period}`;
};

/**
 * Convert 12-hour format time string (h:mm AM/PM) to 24-hour format (HH:mm)
 * @param {string} time12 - Time in 12-hour format (e.g., "1:00 AM", "1:30 PM", "11:45 PM")
 * @returns {string} - Time in 24-hour format (e.g., "01:00", "13:30", "23:45")
 */
export const convertTo24Hour = (time12) => {
  if (!time12 || typeof time12 !== 'string') return time12;
  
  const match = time12.match(/(\d+):(\d+)\s*(AM|PM)/i);
  if (!match) return time12;
  
  let hours = parseInt(match[1], 10);
  const minutes = match[2];
  const period = match[3].toUpperCase();
  
  if (period === 'PM' && hours !== 12) {
    hours += 12;
  } else if (period === 'AM' && hours === 12) {
    hours = 0;
  }
  
  return `${String(hours).padStart(2, '0')}:${minutes}`;
};

/**
 * Format a time range from 24-hour format to 12-hour format
 * @param {string} startTime - Start time in 24-hour format (e.g., "01:00")
 * @param {string} endTime - End time in 24-hour format (e.g., "01:30")
 * @returns {string} - Formatted range in 12-hour format (e.g., "1:00 AM - 1:30 AM")
 */
export const formatTimeRange = (startTime, endTime) => {
  const start12 = convertTo12Hour(startTime);
  const end12 = convertTo12Hour(endTime);
  return `${start12} - ${end12}`;
};

